
export const mobileNav = () => {
	var sideNav = document.getElementById("list-column");
	var navTab = document.getElementById("nav-button-tab");
	var profileColumn = document.getElementById("profile-column");
	
	sideNav.classList.toggle("open");
	navTab.classList.toggle("open");
	profileColumn.classList.toggle("open");
}

export const showPopup = (id) => {
	var elem = document.querySelector('.col.active #'+id);
	elem.style.display = "block";
}

export const hidePopup = (id) => {
	var elem = document.querySelector('.col.active #'+id);
	elem.style.display = "none";
}

export const profileClose = () => {
	console.clear();
	var page = document.querySelector(".col.active");
	var profile = document.querySelector(".col.active .profile");
	profile.style.display = "none";

	if(page.classList.contains("promotions")) {
		document.querySelectorAll("#promotions-column")[0].style.left = "0%";
	}
}

export const showMessage = (message) => {
	var banner = document.getElementById("status-message");
	var copy = banner.querySelector(".copy");
	copy.innerHTML = message;
	banner.classList.toggle("active");
}
export const hideMessage = (success) => {
	var banner = document.getElementById("status-message");
	var copy = banner.querySelector(".copy");
	if (success === true) {
		copy.innerHTML = "Saved...";
		banner.classList.toggle("success");
	} if (success === false) {
		copy.innerHTML = "Something Went Wrong...";
		banner.classList.toggle("fail");
	} if (success === "close") {
		copy.innerHTML = "";
		banner.classList.remove("active");
		banner.classList.remove("success");
		banner.classList.remove("fail");
		return;
	}

	setTimeout(function() {
		copy.innerHTML = "";
		banner.classList.remove("active");
		banner.classList.remove("success");
		banner.classList.remove("fail");
	}, 2500);
}

export const printElem = () => {
    window.print();
}

export const testLoginExpires = () => {
	let expires = localStorage.getItem('expires');
	let token = localStorage.getItem('token');
	let now = Date.now();

	if (expires < now) {
		// console.log("expired");
		window.location.reload();
	} else if (!token) {
		// console.log("no token");
		window.location.reload();
	} else {
		// console.log("valid");
	}
}

export const tabChange = (section, id) => {
	console.log("tab change firing");
    var inputs = document.querySelectorAll("#"+section+"-inputs > .tab");
    var tabs = document.querySelectorAll("#"+section+"-tabs > .tab");

    console.log(inputs, tabs);

    Object.entries(tabs).forEach(([tabs, tab]) => {
		tab.classList.remove("active");
		if(tab.classList.contains(section+"-"+id)) {
			tab.classList.add("active");
		}
	});
    Object.entries(inputs).forEach(([inputs, input]) => {
		input.classList.remove("active");
		if(input.classList.contains(section+"-"+id)) {
			input.classList.add("active");
		}
	});
    var inputControls = document.querySelectorAll("div.tab-controls");
    for (var i = 0; i < inputControls.length; i++) {
        inputControls[i].style.display = "block";
    }         
}

export const toggleStatus = (status, tab, page) => {
	//console.log(status);
	var allClients = document.querySelectorAll("#"+page+" .result-list li");
	var clients = document.querySelectorAll("#"+page+" .result-list ."+status);
	var tabs = document.querySelectorAll("#"+page+" .list-tabs .tab");

	Object.entries(tabs).forEach(([tabs, tab]) => {
		tab.classList.remove("active");
	});
	document.querySelectorAll("#"+page+" #"+tab)[0].classList.add("active");

	Object.entries(allClients).forEach(([allClients, client]) => {
		client.style.display = "none";
	});
	Object.entries(clients).forEach(([clients, client]) => {
		client.style.display = "block";
	});
}

export const accordian = (e) => {
	//console.log(e.target);
	e.target.parentElement.classList.toggle("active");
}

export const addImgTxt = (e) => {
	var widgetId = e.target.getAttribute('data-widgetId');
	var widgetType = e.target.getAttribute('data-widgetType');
	var assetType = e.target.getAttribute('data-assetType');
	var el;

	console.log(widgetId);
	console.log(widgetType);
	console.log(assetType);

	switch(true) {
		case assetType === "images":
			el = document.querySelectorAll("#"+widgetType+"-"+widgetId+" ."+assetType+"-container")[0];
			// console.log(el);
			var inputHTML, options;
			var options2 = "";
			if (widgetType === "popup" || widgetType === "navigation") {
				inputHTML = '<input class="graphic" type="hidden" name="type" placeholder="type" value="graphic" disabled="disabled" />';
			} else {
				if (widgetType === "banner") {
					options = '<option value="desktop" selected>Desktop Graphic</option>'+
							  '<option value="mobile">Mobile Graphic</option>';
					options2 =  '<div class="input-row">'+
									'<label htmlfor="size">Size</label>'+
									'<div class="select"><select name="size" class="size">'+
										'<option value="fullwidth" selected>Full Width</option>'+
										'<option value="fixedwidth">Fixed Width</option>'+
									'</select></div>'+
								'</div>'
				} else if (widgetType === "landing") {
					options = '<option value="background" selected>Background</option>'+
							'<option value="graphic">Sale Graphic</option>'+
							'<option value="mobile">Mobile Sale Graphic</option>';
				} else {
					options = '<option value="background" selected>Background</option>'+
							'<option value="graphic">Sale Graphic</option>';
				}
				inputHTML = '<div class="input-row">'+
					'<label htmlfor="type">Type</label>'+
					'<div class="select"><select name="type" class="typeInput">'+
						options+
					'</select></div>'+
				'</div>'+
				options2;
			}
			el.insertAdjacentHTML(
				'beforeend',
				'<div class="'+assetType+' '+assetType+"-"+widgetId+' new-widget">'+
					'<input type="hidden" name="widgetId" placeholder="widgetId" value="'+widgetId+'" hidden="" class="hidden">'+
					'<div class="input-row">'+
						'<label htmlfor="url">Image</label>'+
						'<div><img src="" />'+
						'<input type="file" name="url" placeholder="url" value="" class="promo-image">'+
						'<span>Max Image Size is 5MB</span></div>'+

					'</div>'+
					inputHTML+
				'</div>'
			);
			break;
		case assetType === "texts":
			el = document.querySelectorAll("#"+widgetType+"-"+widgetId+" ."+assetType+"-container")[0];
			var typeHTML;

			if (widgetType === "navigation") {
				typeHTML = '<input class="copy" type="hidden" name="type" placeholder="type" value="copy" disabled="disabled" />';
			} else if (widgetType === "landing") {
				typeHTML = '<div class="input-row">'+
					'<label htmlfor="type">Type</label>'+
					'<div class="select"><select name="type"  class="typeInput">'+
						'<option value="copy">Copy</option>'+
						'<option value="heading" selected>Heading</option>'+
					'</select></div>'+
				'</div>'
			} else if (widgetType === "email") {
				typeHTML = '<div class="input-row">'+
					'<label htmlfor="type">Type</label>'+
					'<div class="select"><select name="type" class="typeInput">'+
						'<option value="copy" selected>Coupon Copy</option>'+
						'<option value="terms">Terms & Conditions</option>'+
					'</select></div>'+
				'</div>'
			} else {
				typeHTML = '<div class="input-row">'+
					'<label htmlfor="type">Type</label>'+
					'<div class="select"><select name="type" class="typeInput">'+
						'<option value="copy" selected>Copy</option>'+
						'<option value="button">Button</option>'+
					'</select></div>'+
				'</div>'
			}

			el.insertAdjacentHTML(
				'beforeend',
				'<div class="'+assetType+"-"+widgetId+' new-widget">'+
					'<input type="hidden" name="widgetId" placeholder="widgetId" value="'+widgetId+'" hidden="" class="hidden">'+
					typeHTML+
					'<div class="input-row">'+
						'<label htmlfor="text">Text</label>'+
						'<div><textarea name="text" placeholder="write your text here.."></textarea></div>'+
					'</div>'+
				'</div>'
			);
			break;
		default:
			break;
	}
}

















// WEBPACK FOOTER //
// ./src/helpers/uiFunctions/uiActions.js